import React from "react";

export function Intro() {
    return (
        <div id={"intro text"}>
            <p>
                Symbiosis is an interactive digital installation featuring works that explore microbial reproduction, digital decay and digital futures. It showcases pieces devised by four transdisciplinary artists, whose collaborative contributions respond to the biological phenomenon of symbiosis. Through the collective’s transdisciplinary dialogue, sonic, visual, somatic, textual and interactive elements are combined to form a set of interconnected experiences. They invite viewers, listeners, audience members and players to dive into recursive responses to microbial sex processes, crawl through the internet’s squirming and churning ecosystem, embrace microbial sensations, traverse internal landscapes and reach for collective futuring.
            </p>
        </div>
    )
}

export function AboutOrganism() {
    function RandomisedArtistNames() {
        const names = ["Xavier Velastín", "Iris Colomb", "Virág Pázmány", "Maria Cynkier", "Ande Clock", "Mia Windsor", "George Kuhn", "Toi Guy"]

        let shuffledNames = shuffleNames();

        function shuffleNames() {
            const namesCopy = [...names];
            for (let i = namesCopy.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [namesCopy[i], namesCopy[j]] = [namesCopy[j], namesCopy[i]];
            }
            return namesCopy;
        }

        return (
            <div>

                <div>
                    Our current members are: {' '}
                    {shuffledNames.map((name, index) => (
                        <React.Fragment key={index}>
                            {index === shuffledNames.length - 1 ? " and " : ""}
                            <b>{name}</b>
                            {index === shuffledNames.length - 1 ? "." : ", "}
                        </React.Fragment>
                    ))}
                </div>

            </div>
        )
    }
    
    return (
        <div id={"about organism"}>
            <h2>
                The Organism Collective
            </h2>
            <div>
                <p>
                    We are an artist network founded in 2023 with the aim of devising and delivering interdisciplinary digital pieces. We draw inspiration from biological structures like fungal networks, spider webs and microbial communities – both in the kind of work we create, and in how we organise ourselves as a collective.

                </p>

                <RandomisedArtistNames/>

                <p>
                    Visit our website's homepage at <a target={"_blank"} rel={"noreferrer"} href={"https://organism-collective.net/"}>organism-collective.net</a>.
                </p>

            </div>
        </div>
    )
}

export function Credits() {
    return (
        <div id={"credits"}>
            <h2>Credits</h2>
            <h3>Artworks</h3>

            <p><em>paths through the microbial sex loops</em> by Ande Clock and Mia Windsor</p>
            <p><em>decay sim</em> by George Micah Kuhn</p>
            <p><em>Microbial Sex Video Comic</em> by Toi Guy with Mia Windsor, Ande Clock, Saya Naruse and Ella
                Yolande</p>
            <p><em>Cybershore Meditations</em> by Toi Guy with Kiik Amor, Studio Misti and George Micah Kuhn</p>

            <h3>Production Team</h3>

            <p>Maria Cynkier - Digital Artist Coordinator</p>
            <p>Xavier Velastín - Project Designer</p>
            <p>Iris Colomb - Project Designer</p>
            <p>Virág Pázmány - Project Designer</p>
        </div>
    )
}

export function Donate() {
    return (
        <div id={"donate"}>
            <h2>
                Contribute
            </h2>

            <p>
                Putting together Symbiosis involved over 1,000 hours of work - from the initial conceptualising stage, to finding our artists via open call, to creating the pieces, to putting them together in this interactive website. This was supported by our partner organisations and with the generous support of donations.
            </p>
            <p>
                Although this phase of Symbiosis is over, further donations will help us:
            </p>
            <ul>
                <li key={0}>Apply to competitions and festivals that have an application fee,</li>
                <li key={1}>Smooth out the rough edges of our website's user experience,</li>
                <li key={2}>Reach new audiences and communities,</li>
                <li key={3}>Invite more artists to join our network,</li>
                <li key={4}>Develop new digital pieces.</li>
            </ul>
            <p>
                If you would like to contribute to Organism, <b>thank you</b>!

            </p>
            <p>
                The easiest way is to buy us a 'coffee' over at <a target={"_blank"} rel={"noreferrer"} href={"https://www.buymeacoffee.com/organism"}>buymeacoffee.com/organism</a>.
            </p>
            <p>
                If you would like to discuss another way you can support us, email us at <a href={"mailto:organismcollective@gmail.com"}>organismcollective@gmail.com</a>.
            </p>
        </div>
    )
}